import { PlatformName } from "./PlatformName"

export const platform: PlatformName = "web"
